import type { ProjectMeeting } from '../types';

/** When the Advanced → Show meetings toggle is off, markers are hidden. */
export function filterMeetingsForTimeline(
  meetings: ProjectMeeting[],
  showMeetings: boolean,
): ProjectMeeting[] {
  if (!showMeetings) return [];
  return meetings;
}

/** Group meetings by local calendar day key (YYYY-MM-DD) for Gantt day markers. */
export function groupMeetingsByDayKey(meetings: ProjectMeeting[]): Map<string, ProjectMeeting[]> {
  const map = new Map<string, ProjectMeeting[]>();
  for (const m of meetings) {
    const d = m.start instanceof Date ? m.start : new Date(m.start);
    if (Number.isNaN(d.getTime())) continue;
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const list = map.get(key);
    if (list) list.push(m);
    else map.set(key, [m]);
  }
  return map;
}

export function dayKeyFromDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatMeetingWhen(start: Date, end: Date): string {
  const datePart = start.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const timeOpts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' };
  const startT = start.toLocaleTimeString('en-US', timeOpts);
  const endT = end.toLocaleTimeString('en-US', timeOpts);
  return `${datePart} · ${startT} – ${endT}`;
}

export function meetingSummaryDisplay(summary: string | undefined | null): string {
  const t = typeof summary === 'string' ? summary.trim() : '';
  return t || 'No recording';
}
